<template>
  <div class="image-type-switch">
    <div class="image-type-switch__field">
      <input
        id="teaser"
        v-model="localImageType"
        type="radio"
        value="teaser"
        name="imageType"
      />
      <label for="teaser">
        {{
          getProductOverviewTranslations['ProductsOverview.ImageSwitch.Image']
        }}
      </label>
    </div>
    <div class="image-type-switch__field">
      <input
        id="drawing"
        v-model="localImageType"
        type="radio"
        value="drawing"
        name="imageType"
      />
      <label for="drawing">
        {{
          getProductOverviewTranslations['ProductsOverview.ImageSwitch.Drawing']
        }}
      </label>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';

export default {
  name: 'ImageTypeSwitch',
  computed: {
    ...mapGetters('productSearch', ['buildQuery']),
    ...mapState('productSearch', ['imageType']),
    ...mapGetters('translations', ['getProductOverviewTranslations']),
    localImageType: {
      get() {
        return this.imageType;
      },
      set(value) {
        this.setImageType(value);
      }
    }
  },
  methods: {
    ...mapMutations('productSearch', ['setImageType'])
  }
};
</script>

<style lang="scss" scoped>
@import '@/css/src/utilities/_variables.scss';
@import '~bootstrap/scss/mixins';

.image-type-switch {
  display: flex;

  &__field {
    input {
      position: absolute;
      clip: rect(0, 0, 0, 0);
      height: 1px;
      width: 1px;
      border: 0;
      overflow: hidden;

      &:checked + label {
        background-color: $body-color;
        color: $white;
        border-color: $body-color;
      }
    }

    label {
      background-color: $white;
      color: $body-color;
      font-size: 14px;
      line-height: 1;
      text-align: center;
      padding: 14px 20px;

      border: 1px solid rgba(0, 0, 0, 0.2);
      transition: background-color $transition-default-duration
          $transition-default-timing,
        border-color $transition-default-duration $transition-default-timing;

      &:hover {
        cursor: pointer;
      }
    }
  }
}
</style>
